import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../SchedulingStyles/DisciplineDropdown.css";

const DisciplineDropdown = ({ disciplines = [], onSelect }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    onSelect(value);
  };

  return (
    <div className="discipline-dropdown-container">
      <label htmlFor="discipline-select">
        {t("admin_scheduling_new.select_discipline_label")}
      </label>
      <select id="discipline-select" value={selected} onChange={handleChange}>
        <option value="">
          {t("admin_scheduling_new.choose_discipline_option")}
        </option>
        {disciplines.map((d) => (
          <option key={d.id} value={d.id}>
            {d.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DisciplineDropdown;
